import { MessageData } from ".";
import { ProcessOutput } from "./ImageBase";

export enum IFileStatus {
  "Waiting" = "Waiting",
  "Compressing" = "Compressing",
  "Compressed" = "Compressed",
  "CompressError" = "CompressError"
}

export interface IFile {
  originalFile: File;
  compressFile?: File;
  preview?: ProcessOutput;
  compress?: ProcessOutput;
  blob: Blob;
  src?: string;
  width: number;
  height: number;
  name: string;
  status: IFileStatus;
  error?: string;
  percent?: number;
  fileSize?: number;
  compressFileSize?: number;
  id: string;
  md5?: string;
  color?: string;
  blurhash?: string;
  createAt: number;
}

export interface UploadTask {
  file: IFile;
  worker: Worker;
  startEmit: () => void;
  resolve: (info: any) => void;
  reject: (error: any) => void;
}

export class ProcessFileQueue {
  private readonly maxTasks: number;
  private readonly taskQueue: UploadTask[] = [];
  private currentTasks = 0;
  private taskHubQueue: { [key: string]: any };

  constructor(maxTasks: number) {
    this.maxTasks = maxTasks;
    this.taskHubQueue = {};
  }

  public register({
    id,
    resolve,
    worker,
    reject,
    payload,
    active,
    type = "compress",
    quality = 80
  }: {
    id: string;
    payload: MessageData;
    worker?: any;
    type?: "compress" | "preview";
    quality?: number;
    active: () => void;
    resolve: (info: any) => void;
    reject: (error: any) => void;
  }) {
    this.taskHubQueue[id] = {
      worker,
      resolve,
      type,
      reject,
      payload,
      active,
      quality
    };
  }

  public async executeTask(taskId) {
    const { id, payload, active, worker, type, resolve, reject, quality } =
      this.taskHubQueue[taskId] || {};
    try {
      this.currentTasks++;
      console.log(`Task ${taskId} active`);
      active?.();

      const [compressFile, previewFile] = await Promise.all([
        worker.send({
          id,
          payload,
          type
        }),
        worker.send({
          id,
          payload,
          type: "preview"
        })
      ]);
      resolve?.({ ...compressFile, ...previewFile });
      delete this.taskHubQueue[taskId];
      console.log(`Task ${taskId} resolved`);
    } catch (reason) {
      reject?.(reason);
      console.log(`Task ${taskId} did not execute:`, reason.reasonCode);
    } finally {
      this.currentTasks--;
    }
  }

  public async scheduler(end?: () => Promise<void>) {
    const maxParallelTasks = this.maxTasks;
    let taskQueue = Object.keys(this.taskHubQueue);
    const executingTasks = new Set();

    const executeFromQueue = async () => {
      while (taskQueue.length > 0 && this.currentTasks < maxParallelTasks) {
        const taskId = taskQueue.shift();
        if (!executingTasks.has(taskId) && taskId) {
          executingTasks.add(taskId);
          this.executeTask(taskId)
            .then(() => executingTasks.delete(taskId))
            .catch(() => {
              executingTasks.delete(taskId);
            });
        }
      }

      if (taskQueue.length === 0 && executingTasks.size <= 0) {
        end?.();
        return;
      }

      setTimeout(executeFromQueue, 100); // 等待100ms后再次检查并执行剩余任务
    };

    executeFromQueue();
  }
}
